import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import * as workflowsActions from "actions/workflowsActions";
import { chunkArray } from "utils/utils";
import Loading from "components/Loading";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

class AbsenceCalendar extends React.Component {
	getSafeCalendar = () => {
		// La API puede devolver `undefined` si todavía no cargó o falló.
		// Así evitamos crashear al leer `.length` o hacer `.filter`.
		return Array.isArray(this.props.employee_absence_calendar)
			? this.props.employee_absence_calendar
			: [];
	};

	getMonths = () =>
		Array.from({ length: 12 }, (item, i) => {
			const fullCalendar = this.getSafeCalendar();

			const monthCalendar = fullCalendar.filter((o) => {
				if (!o?.day) return false;
				let [year, month, date] = o.day.split("-");
				return month * 1 === i + 1 ? true : false;
			});

			// console.log(monthCalendar);

			// si el primer dia del mes no es lunes, se añaden días vacíos de relleno
			const weekDay = monthCalendar[0]?.weekday ?? 1;
			if (weekDay !== 1) {
				for (let i = weekDay; i > 1; i--) {
					monthCalendar.unshift({ day: null });
				}
			}

			// separa mes en semanas
			const monthCalendarWithWeeks = chunkArray(monthCalendar, 7);

			return (
				<div className="column col-sm-6 col-xl-4" key={i}>
					<article className="card month">
						<h3>{new Date(0, i).toLocaleString(i18next.language || "es-ES", { month: "long" })}</h3>

						<table className="table-calendar">
							<thead>
								<tr>{this.getWeekDays()}</tr>
							</thead>
							<tbody>{this.getWeeks(monthCalendarWithWeeks)}</tbody>
						</table>
					</article>
				</div>
			);
		});

	// starts with a monday
	getWeekDays = () =>
		Array.from({ length: 7 }, (item, i) => (
			<th key={i}>
				{new Date(2021, 10, i + 1).toLocaleString(i18next.language || "es-ES", {
					weekday: "narrow",
				})}
			</th>
		));

	getWeeks = (monthCalendarWithWeeks) =>
		monthCalendarWithWeeks.map((week, i) => {
			//console.log(week);
			return <tr key={i}>{this.getCalendarDays(week)}</tr>;
		});

	getCalendarDays = (week) =>
		week.map((o, i) => {
			if (o.day === null) return <td key={i}></td>;

			let [year, month, date] = o.day.split("-");
			var className = "td-container";
			let innerStyle = {};
			let innerClass = "day-content";

			const hexToRgba = (hex, alpha) => {
				if (!hex) return hex;
				let c = hex.substring(1).split("");
				if (c.length === 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
				c = "0x" + c.join("");
				return `rgba(${(c >> 16) & 255}, ${(c >> 8) & 255}, ${c & 255}, ${alpha})`;
			};

			if (o.absence || (o.day_type && o.day_type.holiday)) {
				var color, tooltipContent, absenceId;

				if (o.absence) {
					const shift = o.shift;
					tooltipContent = o.comments
						? o.comments
						: shift.name + " " + shift.description;
					color = shift.background_color;
					absenceId = "absence_" + shift.id; // Or generic if just based on color: shift.background_color
				}

				if (o.day_type && o.day_type.holiday) {
					const day_type = o.day_type;
					tooltipContent = o.comments
						? o.comments
						: day_type.name + " " + day_type.description;
					color = day_type.color;
					absenceId = "holiday_" + day_type.id;
				}

				if (o.worked_holiday) {
					className += " worked-holiday";
					tooltipContent = (
						<>
							<strong>[Festivo trabajado]</strong>
							<br /> {tooltipContent}
						</>
					);
				}

				// Continuous Block Logic
				const prev = week[i - 1];
				const next = week[i + 1];

				const getAbsenceId = (item) => {
					if (!item || !item.day) return null;
					if (item.absence) return "absence_" + item.shift.id; // OR item.shift.background_color if we want to merge by color
					if (item.day_type && item.day_type.holiday)
						return "holiday_" + item.day_type.id;
					return null;
				};

				const prevId = getAbsenceId(prev);
				const nextId = getAbsenceId(next);
				const currentId = absenceId;

				const isStart = currentId !== prevId;
				const isEnd = currentId !== nextId;

				innerClass += " has-absence";

				// Background with 30% opacity
				const bgColor = hexToRgba(color, 0.3);

				innerStyle = {
					backgroundColor: bgColor,
					borderTop: `1px solid ${color}`,
					borderBottom: `1px solid ${color}`,
					// Removed explicit text color to let CSS decide or inherit.
				};

				if (isStart && isEnd) {
					innerClass += " is-single";
					innerStyle.borderLeft = `1px solid ${color}`;
					innerStyle.borderRight = `1px solid ${color}`;
				} else if (isStart) {
					innerClass += " is-start";
					innerStyle.borderLeft = `1px solid ${color}`;
				} else if (isEnd) {
					innerClass += " is-end";
					innerStyle.borderRight = `1px solid ${color}`;
				} else {
					innerClass += " is-middle";
				}

				const tooltip = (
					<Tooltip className="tooltip-calendar">{tooltipContent}</Tooltip>
				);

				return (
					<td key={i}>
						<div className={className}>
							<OverlayTrigger key={i} placement="top" overlay={tooltip}>
								<div className={innerClass} style={innerStyle}>
									<span>{date}</span>
								</div>
							</OverlayTrigger>
						</div>
					</td>
				);
			}

			return (
				<td key={i}>
					<div className={className}>
						<div className={innerClass}>{date}</div>
					</div>
				</td>
			);
		});

	render() {
		const calendar = this.getSafeCalendar();

		if (this.props.loading && calendar.length === 0) {
			return <Loading />;
		} else if (calendar.length === 0) {
			return <p className="no-results">{this.props.t('absences.calendar.loadError')}</p>;
		}

		return <div className="row list-calendar">{this.getMonths()}</div>;
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		user: reducers.authReducer.user,
		loading: reducers.workflowsReducer.loading,
	};
};

export default connect(mapStateToProps, workflowsActions)(withTranslation()(AbsenceCalendar));
